import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { IncomingHttpHeaders } from 'http';

/**
 * APIエラー時に返すオブジェクト
 */
export interface RejectedValue {
  message: string;
  redirect: boolean;
}

// 全種保存条件取得API
export const getAllSavedSearches = createAsyncThunk<
  SavedSearchResponse[],
  {
    headers?: IncomingHttpHeaders;
  },
  {
    rejectValue: RejectedValue;
  }
>('savedSearches/getAllAllSavedSearches', async ({ headers }, thunkAPI) => {
  try {
    const savedParams = await apiClient.api.v1.savedSearches.$get({
      config: { headers },
    });
    return savedParams;
  } catch (error) {
    const axiosError = error as AxiosError;
    return thunkAPI.rejectWithValue({
      message: `検索保存条件取得失敗 message:${axiosError.message}`,
      redirect: true,
    });
  }
});

// 保存条件取得API
export const getSavedSearch = createAsyncThunk<
  SavedSearchResponse,
  {
    headers?: IncomingHttpHeaders;
    mpsc_dtno: string;
  },
  {
    rejectValue: RejectedValue;
  }
>('savedSearches/getSavedSearch', async ({ headers, mpsc_dtno }, thunkAPI) => {
  try {
    const savedParams = await apiClient.api.v1.savedSearches
      ._no(mpsc_dtno)
      .$get({ config: { headers } });
    return savedParams;
  } catch (error) {
    const axiosError = error as AxiosError;
    return thunkAPI.rejectWithValue({
      message: `検索保存条件取得失敗 message:${axiosError.message} mpsc_dtno:${mpsc_dtno}}`,
      redirect: true,
    });
  }
});
